import search from './search.js';
import returnModel from './return.js';
import user from './user.js';
const modules = {
    search,
    returnModel,
    user
}

export default modules;